import { motion } from 'framer-motion';
import { Smartphone, Coffee, Gift, ChevronDown } from 'lucide-react';

const HeroContent = () => {
  return (
    <div className="w-full md:w-[55%] relative z-10 flex flex-col justify-center p-4 sm:p-8 md:p-12 lg:p-16 xl:p-20 min-h-[auto] md:min-h-[100vh] pt-24 sm:pt-28 md:pt-32 lg:pt-36">
      <div className="relative z-10 flex flex-col h-full justify-center space-y-8 sm:space-y-10 mt-6 sm:mt-8 md:mt-0 max-w-xl mx-auto md:mx-0">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="space-y-3 sm:space-y-4 max-w-lg"
        >
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold leading-[1.15] text-gray-900 tracking-tight">
            One portal for travellers <span className="text-[#067978]">on-trip experiences.</span>
          </h1>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 font-normal leading-relaxed max-w-md pt-1 sm:pt-2">
            Add Trrip to any booking. Your clients carry your branded app: dining, activities, and live updates - all in one place.
          </p>
        </motion.div>

        {/* Features List */}
        <motion.div
          variants={{
            hidden: { opacity: 0 },
            show: {
              opacity: 1,
              transition: { staggerChildren: 0.2, delayChildren: 0.4 }
            }
          }}
          initial="hidden"
          animate="show"
          className="space-y-4 sm:space-y-6 mt-6 sm:mt-10"
        >
          <motion.div
            variants={{ hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0 } }}
            className="flex items-center gap-3 sm:gap-5"
          >
            <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-full border-2 border-[#067978]/20 bg-white text-[#067978] shadow-sm">
              <Coffee size={18} className="sm:w-5 sm:h-5" />
            </div>
            <span className="text-xs sm:text-base text-gray-800 font-medium tracking-wide">
              Curated dining, shopping & activities
            </span>
          </motion.div>

          <motion.div
            variants={{ hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0 } }}
            className="flex items-center gap-3 sm:gap-5"
          >
            <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-full border-2 border-[#067978]/20 bg-white text-[#067978] shadow-sm">
              <Smartphone size={18} className="sm:w-5 sm:h-5" />
            </div>
            <span className="text-xs sm:text-base text-gray-800 font-medium tracking-wide">
              One white-labelled app for travellers
            </span>
          </motion.div>

          <motion.div
            variants={{ hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0 } }}
            className="flex items-center gap-3 sm:gap-5"
          >
            <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-full border-2 border-[#067978]/20 bg-white text-[#067978] shadow-sm">
              <Gift size={18} className="sm:w-5 sm:h-5" />
            </div>
            <span className="text-xs sm:text-base text-gray-800 font-medium tracking-wide">
              Earn rewards across our partner network
            </span>
          </motion.div>
        </motion.div>

        {/* Scroll Indicator */}
        <div className="w-full flex justify-center md:justify-start mt-8 sm:mt-12 z-30">
          <div
            onClick={() =>
              document.getElementById('about-section')?.scrollIntoView({ behavior: 'smooth' })
            }
            className="flex flex-col items-center cursor-pointer group"
          >
            <span className="text-gray-500 text-[10px] font-medium mb-1.5 tracking-widest uppercase group-hover:text-[#067978] transition-colors">
              Scroll to Explore
            </span>
            <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full border border-gray-300 flex items-center justify-center group-hover:border-[#067978] transition-all">
              <ChevronDown className="text-gray-400 group-hover:text-[#067978]" size={14} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroContent;
